import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SiteFieldHighlightService {
  private highlightSignal = signal<string[]>([]);
  setManualTax = signal<boolean>(false);

  constructor() { }

  setHighlightedFields(fields: string[]) {
    this.highlightSignal.set(fields);
  }

  highlightTaxFields() {
    this.highlightSignal.set(['rate', 'code']);
  }

  getHighlightSignal() {
    return this.highlightSignal;
  }
}
